import { AxiosResponse } from 'axios';
import { ApiService } from './api';

// 历史记录查询参数接口
export interface HistoryQueryParams {
  userId: string;
  id?: string;
  startTime?: number;
  endTime?: number;
  pageSize?: number;
  current?: number;
}

// 历史记录数据接口
export interface HistoryRecord {
  id: string;
  userId: string;
  createTime: number;
  result: string;
  input: string;
  email?: string;
  audioUsage: number;
}

// 带评测状态的历史记录数据接口
export interface HistoryRecordWithEvaluation extends HistoryRecord {
  hasEvaluation: boolean; // 是否存在评测数据
  evaluationStatus?: string; // 评测状态：PENDING, SUCCESS, FAILED
  totalScore?: number; // 总分
  informationScore?: number; // 信息保留率得分
  detailScore?: number; // 细节完整性得分
  logicScore?: number; // 分类与逻辑得分
  grammarScore?: number; // 语法/专业性得分
}

// 分页响应接口
export interface HistoryPageResponse {
  success: boolean;
  data: {
    list: HistoryRecord[];
    total: number;
    current: number;
    pageSize: number;
  };
  message?: string;
}

// 带评测状态的分页响应接口
export interface HistoryPageWithEvaluationResponse {
  success: boolean;
  data: {
    list: HistoryRecordWithEvaluation[];
    total: number;
    current: number;
    pageSize: number;
  };
  message?: string;
}

// 历史记录分析API服务
export class HistoryAnalysisApi {
  // 获取历史记录列表（支持时间范围筛选）
  static async getHistoryList(params: HistoryQueryParams): Promise<AxiosResponse<HistoryPageResponse>> {
    return ApiService.getHistoryList(params);
  }

  // 获取带有评测状态的历史记录列表
  static async getHistoryListWithEvaluation(params: HistoryQueryParams): Promise<AxiosResponse<HistoryPageWithEvaluationResponse>> {
    return ApiService.getHistoryListWithEvaluation(params);
  }

  // 重新评测
  static async reEvaluate(historyId: string): Promise<AxiosResponse> {
    return ApiService.reEvaluate(historyId);
  }
}